import './CurrentShares.css'
import cn from 'clsx'
import * as React from 'react'
import CopyToClipboard from 'react-clipboard.js'
import { connect } from 'react-redux'
import type { Recipient } from 'types/list'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import Button from 'components/ui/button'
import DataTable from 'components/ui/data-table'
import ModalDialog from 'components/ui/modal-dialog'
import PricingBadge from 'components/ui/pricing-badge'
import Tooltip from 'components/ui/tooltip'
import UserAvatar from 'components/ui/user-avatar'
import EditSvg from 'assets/icons/edit.svg'

type SharesItem = {
  id: number
} & Recipient
type Props = {
  disabledShares: Record<number, boolean>
  sharesItems: SharesItem[]
  onSuccessfulCopyUrl: (...args: Array<any>) => any
  onErrorCopyUrl: (...args: Array<any>) => any
  onEditField: any
  // TODO: clean-up onStatsClick
  // onStatsClick: () => mixed,
  onUserClick: (arg0: Recipient) => void
  onExpandShares: (...args: Array<any>) => any
  onCancelShare: (...args: Array<any>) => any
  isFeatureEnabled: boolean
  isPhone: boolean
}

class CurrentShares extends React.Component<
  Props,
  {
    linkDisablingModal:
      | {
          recipient: {
            share_id?: number
          }
        }
      | null
      | undefined
  }
> {
  state = {
    linkDisablingModal: null,
  }
  _disableShare = (
    recipient: {
      share_id?: number
    },
    shareDisabled: boolean,
  ) => {
    this.props.onCancelShare(recipient, !shareDisabled)
  }
  _handleDisablingConfirm = () => {
    if (!this.state.linkDisablingModal) return
    const { recipient } = this.state.linkDisablingModal

    this._disableShare(recipient, false)

    this._handleDisablingCancel()
  }
  _handleDisablingCancel = () => {
    this.setState({
      linkDisablingModal: null,
    })
  }

  _renderRecipient(recipient: SharesItem) {
    const {
      sharesItems,
      onSuccessfulCopyUrl,
      onErrorCopyUrl,
      onEditField,
      onUserClick,
      isFeatureEnabled,
      isPhone,
    } = this.props
    const email = recipient.email
    let name = recipient.name || ''
    const duplicates = sharesItems.filter(x => x.recipient_id === recipient.id)
    const nonUnique = duplicates.length > 1

    if (nonUnique && name) {
      const duplicatesBefore = duplicates.indexOf(recipient) + 1
      name = `${name} inbox ${duplicatesBefore.toString()}`
    }

    const hasContactLink = !!recipient.contact

    const title = hasContactLink ? 'View in contacts' : undefined
    const onTextClick = hasContactLink
      ? () => onUserClick(recipient)
      : undefined
    let nameField = (
      <div className="flc">
        {/* TODO: clean-up */}
        {/* <RecipientAvatar value={name} /> */}
        <UserAvatar
          className="PlaylistStats_UserAvatar"
          name={name}
          size="24px"
          fontSize="11px"
        />
        <span
          className={cn('CurrentShares_ShareName', {
            CurrentShares_Link: hasContactLink,
          })}
          title={title}
          onClick={onTextClick}
        >
          {recipient.contact?.name || name}
          {hasContactLink && <EditSvg width="24" height="24" />}
        </span>
      </div>
    )

    let emailField = (
      <div
        className={cn('CurrentShares_Name', {
          CurrentShares_Link: hasContactLink,
        })}
        title={title}
        onClick={onTextClick}
      >
        {email}
      </div>
    )

    let shareDisabled = recipient.disabled
    const shareDisabledOverride = this.props.disabledShares[recipient.id]

    if (typeof shareDisabledOverride === 'boolean') {
      shareDisabled = shareDisabledOverride
    }

    let url = (
      <CopyToClipboard
        className="PlaylistShareAssign_Link"
        onSuccess={() => onSuccessfulCopyUrl(recipient)}
        onError={() => onErrorCopyUrl(recipient)}
        data-clipboard-text={recipient.recipient_view_url}
      >
        {!isPhone ? (
          'Copy URL'
        ) : (
          <Button appearance="icon" icon="link" tooltip="Copy URL" compact />
        )}
      </CopyToClipboard>
    )
    let description

    if (isFeatureEnabled) {
      if (shareDisabled) {
        description = 'Re-enable link'
      } else {
        description = 'Disable link'
      }
    } else {
      description = (
        <>
          This feature lets you disable share links.
          <br />
          To unlock this feature please <PricingBadge title="UPGRADE" />
        </>
      )
    }

    const action = (
      <Tooltip content={description}>
        <Button
          appearance="icon"
          compact
          disabled={!isFeatureEnabled}
          icon={shareDisabled ? 'reload' : 'close'}
          onClick={() => {
            if (shareDisabled) {
              this._disableShare(recipient, shareDisabled)
            } else {
              this.setState({
                linkDisablingModal: {
                  recipient,
                },
              })
            }
          }}
        />
      </Tooltip>
    )
    return {
      key: recipient.id,
      recipient: nameField,
      email: emailField,
      url,
      action,
    } // TODO: clean-up
    // return (
    //   <div
    //     key={recipient.id}
    //     className={cn('row CurrentShares_ShareRow', {
    //       disabled: shareDisabled,
    //     })}
    //   >
    //     <div className="col-sm-4 col-xs-10 CurrentShares_ShareSubrow">
    //       {nameField}
    //     </div>
    //     <div className="col-sm-5 hidden-mobile CurrentShares_SecondRow">
    //       {emailField}
    //     </div>
    //     <div className="col-sm-2 hidden-mobile" />
    //     <div className="col-sm-1 col-xs-2 end-xs" />
    //   </div>
    // )
  }

  render() {
    const { sharesItems } = this.props
    return (
      <div className="CurrentShares_Table">
        {this.state.linkDisablingModal && (
          <ModalDialog
            title="Disable link"
            primaryAction={{
              caption: 'Confirm',
              onClick: this._handleDisablingConfirm,
            }}
            status="danger"
            onCancel={this._handleDisablingCancel}
          >
            Are you sure you want to disable this link? This link will no longer
            be accessible.
          </ModalDialog>
        )}
        {/* TODO: clean-up */}
        {/* <div className="Form_Label PlaylistShareAssign_CurrentContacts"> */}
        {/*   {sharesItems.length > 0 && ( */}
        {/*     <div className="row"> */}
        {/*       <div className="col-xs-9"> */}
        {/*         <b>Current share URLs</b> */}
        {/*       </div> */}
        {/*       <div className="col-xs-3"> */}
        {/*         <button */}
        {/*           className="PlaylistShareAssign_Link right hidden-mobile" */}
        {/*           onClick={onStatsClick} */}
        {/*         > */}
        {/*           Access stats */}
        {/*         </button> */}
        {/*       </div> */}
        {/*     </div> */}
        {/*   )} */}
        {/* </div> */}
        {sharesItems.length > 0 && (
          <DataTable
            appearance="plain"
            columns={[
              {
                id: 'recipient',
                name: 'Current share Url',
              },
              {
                id: 'email',
                name: 'Email',
              },
              {
                id: 'url',
                name: 'URL',
                width: 'content',
              },
              {
                contentType: 'button',
                id: 'action',
                name: 'Action',
                width: 'content',
              },
            ]}
            data={sharesItems.map(r => this._renderRecipient(r))}
          />
        )}
      </div>
    )
  }
}

export default connect(state => {
  return {
    isPhone: isDeviceTypePhone(state),
  }
})(CurrentShares) as any
